import { createContext, useContext } from 'react';

export const SaleFormContext = createContext({});

export function useSaleFormContext() {
    return useContext(SaleFormContext);
}
